import {MoodType, Ui} from '../types';
import BREATHING from './breathing.json';
import CIRCLING_SLOW from './circling_slow.json';
import CONFETTI from './confetti.json';
import DISCO from './disco.json';
import FADE from './fade.json';
import LAVA_LAMP from './lava_lamp.json';
import NO_ANIMATION from './no_animation.json';
import PARTY_MODE from './party_mode.json';
import SPIN from './spin.json';
import SPLIT_GRADIENT from './split_gradient.json';
import VERTICAL_SLIDESHOW from './vertical_slideshow.json';

const typeSafe = <T extends {ui: (Omit<Ui, 'type'> & {type: string})[]}>({
  ui,
  ...value
}: T) => ({
  ...value,
  ui: ui.map(value => value as Ui),
});

export const LED3Data = {
  [MoodType.NO_ANIMATION]: typeSafe(NO_ANIMATION),
  [MoodType.DISCO]: typeSafe(DISCO),
  [MoodType.FADE]: typeSafe(FADE),
  [MoodType.SPIN]: typeSafe(SPIN),
  [MoodType.SPLIT_GRADIENT]: typeSafe(SPLIT_GRADIENT),
  [MoodType.VERTICAL_SLIDESHOW]: typeSafe(VERTICAL_SLIDESHOW),
  [MoodType.TORNADO]: typeSafe(NO_ANIMATION),
  [MoodType.BREATHING]: typeSafe(BREATHING),
  [MoodType.CIRCLING_SLOW]: typeSafe(CIRCLING_SLOW),
  [MoodType.LAVA_LAMP]: typeSafe(LAVA_LAMP),
  [MoodType.CONFETTI]: typeSafe(CONFETTI),
};

export const LED3PartyModeData = typeSafe(PARTY_MODE);
